import React, {Component} from 'react';
import {Switch, Route, Link} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'
import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions.js';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';

import LoginForm from "../COMPONENTS/LoginForm";

function mapStateToProps(state) {
    return {
        OPEN_LOGIN: state.OPEN_LOGIN
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}

class LoginModal extends Component {

    /// CONSTRUCTOR ///
    constructor(props)
    {
        super(props);
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        if (this.props.OPEN_LOGIN !== prevProps.OPEN_LOGIN) {
            if (window.innerWidth < 1200) {
                if (!this.props.OPEN_LOGIN) {
                    document.body.classList.remove("modal-open");
                    document.documentElement.scrollTop = this.OFFSET;
                } else {
                    this.OFFSET = window.pageYOffset || document.documentElement.scrollTop;
                    document.body.classList.add("modal-open");
                }
            }
        }
    }

    renderContent = () =>
    {
        if (this.props.OPEN_LOGIN) {
            return <LoginForm/>
        }
    }

    render()
    {
        if (this.props.OPEN_LOGIN) {
            return (
                <div className="modal">
                    <div className="modal-overlay" onClick={() => this.props.openLogin(false)}>
                    </div>
                    <div className="modal-box">
                        {this.renderContent()}
                    </div>
                </div>
            );
        } else {
            return false;
        }
    }
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(LoginModal);